import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { IdService } from '../../../shared/services/id.service';

@Component({
	selector: 'rbc-tab-content',
	templateUrl: './tab-content.component.html',
	styleUrls: ['./tab-content.component.scss']
})
export class TabContentComponent implements OnInit, OnDestroy {
	// Input Parameters
	@Input() id: string;
	@Input() name: number | string;
	@Input() disabled: boolean = false;
	@Input() hasTransition: boolean = true;

	index: number = 0;
	isActive: boolean = false;

	constructor(private idService: IdService) {}

	ngOnInit() {
		this.id = this.id ? this.id : this.idService.generate();
	}

	ngOnDestroy(): void {
		this.idService.remove(this.id);
	}
}
